const DEFAULT_ORG_FONT = 'Inter, system-ui, -apple-system, sans-serif';

type OrgTextStyleDefaults = {
  fontStyle?: string;
  textDecoration?: string;
};

type OrgTextStyleResult = {
  fontStyle?: string;
  textDecoration?: string;
  fontFamily?: string;
};

const toNumber = (value: unknown): number | null => {
  if (value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const isBoldWeight = (value: unknown): boolean => {
  if (typeof value === 'string') {
    const normalized = value.toLowerCase();
    if (normalized === 'bold') return true;
    const numeric = toNumber(normalized);
    return numeric !== null && numeric >= 600;
  }
  const numeric = toNumber(value);
  return numeric !== null && numeric >= 600;
};

const isItalicStyle = (value: unknown): boolean => {
  if (typeof value !== 'string') return false;
  return value.toLowerCase().includes('italic');
};

export const resolveOrgTextStyle = (
  attrs: Record<string, unknown>,
  defaults: OrgTextStyleDefaults = {},
  fontFamilyFallback?: string
): OrgTextStyleResult => {
  const hasUserStyle =
    attrs.fontWeight !== undefined ||
    attrs.fontStyle !== undefined ||
    attrs.textDecoration !== undefined;

  const fontFamily =
    (typeof attrs.fontFamily === 'string' && attrs.fontFamily.trim()
      ? attrs.fontFamily
      : undefined) ??
    (typeof fontFamilyFallback === 'string' && fontFamilyFallback.trim()
      ? fontFamilyFallback
      : undefined) ??
    DEFAULT_ORG_FONT;

  if (!hasUserStyle) {
    return {
      fontStyle: defaults.fontStyle,
      textDecoration: defaults.textDecoration,
      fontFamily,
    };
  }

  const bold = isBoldWeight(attrs.fontWeight);
  const italic = isItalicStyle(attrs.fontStyle);
  const fontStyle = bold && italic ? 'bold italic' : bold ? 'bold' : italic ? 'italic' : 'normal';
  const textDecoration =
    typeof attrs.textDecoration === 'string' ? attrs.textDecoration : 'none';

  return {
    fontStyle,
    textDecoration,
    fontFamily,
  };
};
